/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as SignInIndexRouteImport } from './routes/sign-in/index'
import { Route as AuthIndexRouteImport } from './routes/_auth/index'
import { Route as AuthUsageIndexRouteImport } from './routes/_auth/usage/index'
import { Route as AuthSettingsIndexRouteImport } from './routes/_auth/settings/index'
import { Route as AuthModelsIndexRouteImport } from './routes/_auth/models/index'
import { Route as AuthKeysIndexRouteImport } from './routes/_auth/keys/index'
import { Route as AuthClientsIndexRouteImport } from './routes/_auth/clients/index'
import { Route as AuthAuditIndexRouteImport } from './routes/_auth/audit/index'
import { Route as AuthClientsClientIdRouteImport } from './routes/_auth/clients/$clientId'

const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInIndexRoute = SignInIndexRouteImport.update({
  id: '/sign-in/',
  path: '/sign-in/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthIndexRoute = AuthIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthUsageIndexRoute = AuthUsageIndexRouteImport.update({
  id: '/usage/',
  path: '/usage/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthSettingsIndexRoute = AuthSettingsIndexRouteImport.update({
  id: '/settings/',
  path: '/settings/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthModelsIndexRoute = AuthModelsIndexRouteImport.update({
  id: '/models/',
  path: '/models/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthKeysIndexRoute = AuthKeysIndexRouteImport.update({
  id: '/keys/',
  path: '/keys/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsIndexRoute = AuthClientsIndexRouteImport.update({
  id: '/clients/',
  path: '/clients/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthAuditIndexRoute = AuthAuditIndexRouteImport.update({
  id: '/audit/',
  path: '/audit/',
  getParentRoute: () => AuthRoute,
} as any)
const AuthClientsClientIdRoute = AuthClientsClientIdRouteImport.update({
  id: '/clients/$clientId',
  path: '/clients/$clientId',
  getParentRoute: () => AuthRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthIndexRoute
  '/sign-in/': typeof SignInIndexRoute
  '/clients/$clientId': typeof AuthClientsClientIdRoute
  '/audit/': typeof AuthAuditIndexRoute
  '/clients/': typeof AuthClientsIndexRoute
  '/keys/': typeof AuthKeysIndexRoute
  '/models/': typeof AuthModelsIndexRoute
  '/settings/': typeof AuthSettingsIndexRoute
  '/usage/': typeof AuthUsageIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof AuthIndexRoute
  '/sign-in': typeof SignInIndexRoute
  '/clients/$clientId': typeof AuthClientsClientIdRoute
  '/audit': typeof AuthAuditIndexRoute
  '/clients': typeof AuthClientsIndexRoute
  '/keys': typeof AuthKeysIndexRoute
  '/models': typeof AuthModelsIndexRoute
  '/settings': typeof AuthSettingsIndexRoute
  '/usage': typeof AuthUsageIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_auth': typeof AuthRouteWithChildren
  '/_auth/': typeof AuthIndexRoute
  '/sign-in/': typeof SignInIndexRoute
  '/_auth/clients/$clientId': typeof AuthClientsClientIdRoute
  '/_auth/audit/': typeof AuthAuditIndexRoute
  '/_auth/clients/': typeof AuthClientsIndexRoute
  '/_auth/keys/': typeof AuthKeysIndexRoute
  '/_auth/models/': typeof AuthModelsIndexRoute
  '/_auth/settings/': typeof AuthSettingsIndexRoute
  '/_auth/usage/': typeof AuthUsageIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in/'
    | '/clients/$clientId'
    | '/audit/'
    | '/clients/'
    | '/keys/'
    | '/models/'
    | '/settings/'
    | '/usage/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/sign-in'
    | '/clients/$clientId'
    | '/audit'
    | '/clients'
    | '/keys'
    | '/models'
    | '/settings'
    | '/usage'
  id:
    | '__root__'
    | '/_auth'
    | '/_auth/'
    | '/sign-in/'
    | '/_auth/clients/$clientId'
    | '/_auth/audit/'
    | '/_auth/clients/'
    | '/_auth/keys/'
    | '/_auth/models/'
    | '/_auth/settings/'
    | '/_auth/usage/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthRoute: typeof AuthRouteWithChildren
  SignInIndexRoute: typeof SignInIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in/': {
      id: '/sign-in/'
      path: '/sign-in'
      fullPath: '/sign-in/'
      preLoaderRoute: typeof SignInIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/': {
      id: '/_auth/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/usage/': {
      id: '/_auth/usage/'
      path: '/usage'
      fullPath: '/usage/'
      preLoaderRoute: typeof AuthUsageIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/settings/': {
      id: '/_auth/settings/'
      path: '/settings'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthSettingsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/models/': {
      id: '/_auth/models/'
      path: '/models'
      fullPath: '/models/'
      preLoaderRoute: typeof AuthModelsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/keys/': {
      id: '/_auth/keys/'
      path: '/keys'
      fullPath: '/keys/'
      preLoaderRoute: typeof AuthKeysIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/': {
      id: '/_auth/clients/'
      path: '/clients'
      fullPath: '/clients/'
      preLoaderRoute: typeof AuthClientsIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/audit/': {
      id: '/_auth/audit/'
      path: '/audit'
      fullPath: '/audit/'
      preLoaderRoute: typeof AuthAuditIndexRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/clients/$clientId': {
      id: '/_auth/clients/$clientId'
      path: '/clients/$clientId'
      fullPath: '/clients/$clientId'
      preLoaderRoute: typeof AuthClientsClientIdRouteImport
      parentRoute: typeof AuthRoute
    }
  }
}

interface AuthRouteChildren {
  AuthIndexRoute: typeof AuthIndexRoute
  AuthClientsClientIdRoute: typeof AuthClientsClientIdRoute
  AuthAuditIndexRoute: typeof AuthAuditIndexRoute
  AuthClientsIndexRoute: typeof AuthClientsIndexRoute
  AuthKeysIndexRoute: typeof AuthKeysIndexRoute
  AuthModelsIndexRoute: typeof AuthModelsIndexRoute
  AuthSettingsIndexRoute: typeof AuthSettingsIndexRoute
  AuthUsageIndexRoute: typeof AuthUsageIndexRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthIndexRoute: AuthIndexRoute,
  AuthClientsClientIdRoute: AuthClientsClientIdRoute,
  AuthAuditIndexRoute: AuthAuditIndexRoute,
  AuthClientsIndexRoute: AuthClientsIndexRoute,
  AuthKeysIndexRoute: AuthKeysIndexRoute,
  AuthModelsIndexRoute: AuthModelsIndexRoute,
  AuthSettingsIndexRoute: AuthSettingsIndexRoute,
  AuthUsageIndexRoute: AuthUsageIndexRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AuthRoute: AuthRouteWithChildren,
  SignInIndexRoute: SignInIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
